import { type CallProblem, type CallProblemKind } from "@/lib/types";

export const PROBLEM_LABEL: Record<CallProblemKind, string> = {
  incomplete: "⚠ Emmy: nedokončeno",
  no_recording: "⚠ Emmy: bez nahrávky",
};

export const PROBLEM_BADGE_STYLE: Record<CallProblemKind, string> = {
  incomplete: "bg-red-50 text-red-700",
  no_recording: "bg-amber-50 text-amber-700",
};

export const PROBLEM_BOX_STYLE: Record<CallProblemKind, string> = {
  incomplete: "border-red-200 bg-red-50 text-red-800",
  no_recording: "border-amber-200 bg-amber-50 text-amber-800",
};

export const PROBLEM_TITLE: Record<CallProblemKind, string> = {
  incomplete: "Zápis do Emmy se nedokončil",
  no_recording: "Nahrávka se do Emmy nepřipojila",
};

export const PROBLEM_TEXT: Record<CallProblemKind, string> = {
  incomplete:
    "Požadavek v Emmy může chybět, nebo na něm chybí shrnutí, přepis či nahrávka. Zkontrolujte Emmy a doplňte ho ručně. Přepis, shrnutí a nahrávka jsou uložené níže.",
  no_recording:
    "Požadavek je v Emmy, ale bez nahrávky hovoru. Nahrávka je níže. Pokud se to opakuje u všech hovorů ordinace, má v Emmy vypnuté přílohy (modul Zabezpečené přílohy).",
};

export const ERROR_KIND_LABEL: Record<string, string> = {
  rejected: "Emmy požadavek odmítla",
  auth: "Přihlášení do Emmy selhalo",
  technical: "Technická chyba",
};

export const isOpenProblem = (
  problem: CallProblem | null | undefined,
): problem is CallProblem => problem != null && !problem.resolvedAt;
